<template>
  <div>
  <b-modal
    title="帳單詳情"
    size="xl"
    centered
    hide-footer
    header-class="head-modal"
    v-model="modalShow"
  >
    <div class="contract-data mb-2">
      <div>繳款日期：{{ data.pay_date_S }} ~ {{ data.pay_date_E }}</div>

      <div>繳款地點：{{ data.payment_source }}</div>

      <div class="d-flex align-items-center justify-content-end">
        <span class="mr-2">金額合計：{{ data.total }}</span>

        <convert-excel
          class="btn btn-success btn-sm"
          :data="excel_json.data"
          :fields="excel_json.fields"
          :worksheet="excel_json.worksheet"
          :name="excel_json.name"
          :type="excel_json.type"
        >
          下載
        </convert-excel>
      </div>
    </div>

    <tables-page
      :tableData="table_data"
      :tableFields="table_fields"
      v-on:result="getBill"
    >
      <template #cell(join_date)="row">
        {{ convertRocDate(row.item.join_date, false) }}
      </template>

      <template #cell(amount)="row">
        {{ row.item.details.amount }}
      </template>

      <template #cell(period)="row">
        {{ row.item.details.period }}
      </template>

      <template #cell(type)="row">
        {{ getBillFeeDescription(row.item.details) }}
      </template>

      <template #cell(payment_source)="row">
        {{ row.item.details.payment_source }}
      </template>

      <template #cell(payment_at)="row">
        {{ convertRocDate(row.item.details.payment_at, false) }}
      </template>
    </tables-page>

    <b-overlay :show="status.isLoading" no-wrap></b-overlay>
  </b-modal>
</div>
</template>

<script>
import TablesPage from "@/components/layouts/TablesPage";
import ConvertExcel from "@/components/common/ConvertExcel";
import billApi from "@/models/API/billApi";
import { convertRocDate, convertDateFormat, getBillFeeDescription } from "@/models/HELPERS/common.js";

export default {
  name: 'DetailedReportModal',
  model: {
    prop: 'show',
    event: 'change'
  },
  props: {
    show: {
      type: Boolean,
      required: false,
      default: false
    },
    data: {
      type: Object,
      required: false,
      default: () => {}
    }
  },
  components: {
    TablesPage,
    ConvertExcel
  },
  data () {
    return {
      status: {
        isLoading: false
      },
      table_fields: [
        {
          key: "sales_number",
          label: "業務編號",
        },
        {
          key: "sales_name",
          label: "業務姓名",
        },
        {
          key: "number",
          label: "契約編號",
        },
        {
          key: "member_name",
          label: "姓名",
        },
        {
          key: "period",
          label: "期別",
        },
        {
          key: "type",
          label: "類別",
        },
        {
          key: "amount",
          label: "互助金",
        },
        {
          key: "payment_at",
          label: "繳款時間",
        },
        {
          key: "payment_source",
          label: "繳款來源",
        },

        {
          key: "join_date",
          label: "入會日期",
        },
        {
          key: "plan",
          label: "組別",
        },
        // {
        //   key: "member_ID_number",
        //   label: "身分證",
        // },
        // {
        //   key: "",
        //   label: "建檔帳號",
        // },
      ],
      table_data: [],
      excel_json: {
        fields: {},
        data: [],
        worksheet: 'My Worksheet',
        name: '查詢已繳費.csv',
        type: 'csv'
      }
    }
  },
  computed: {
    modalShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('change', value);
      }
    },
  },
  watch: {
    show: {
      handler(newValue, oldValue) {
        if (newValue) this.getBill();
      },
      immediate: false
    }
  },
  mounted() {
    this.billApi = new billApi();
    this.load();
  },
  methods: {
    // 首次載入讀取
    load() {

    },
    convertRocDate,
    getBillFeeDescription,
    // 查詢帳單報表
    getBill() {
      this.status.isLoading = true;

      const params = {
        ...this.data,
      };

      this.billApi.getBill((response) => {
        const res = response.data;

        this.table_data = [];

        res.data.forEach(item => {
          const data = item;

          item.details.forEach(item_details => {
            this.table_data.push({
              ...data,
              details: item_details
            })
          })
        })

        this.initExcelData();

        this.status.isLoading = false;
      }, params, false)
    },
    // 初始化excel資料
    initExcelData() {
      let fields = {}, data = [];

      this.table_fields.forEach(fields_item => {
        fields = {
          ...fields,
          [fields_item.label]: fields_item.key
        }
      })

      this.table_data.forEach(data_item => {
        let temp_data = {};

        this.table_fields.forEach(fields_item => {
          if (fields_item.key === 'amount' || fields_item.key === 'period' || fields_item.key === 'payment_source') {
            temp_data = {
              ...temp_data,
              [fields_item.key]: data_item.details[fields_item.key] !== null ? data_item.details[fields_item.key] : ''
            }
          } else if (fields_item.key === 'payment_at') {
            temp_data = {
              ...temp_data,
              [fields_item.key]: data_item.details[fields_item.key] ? convertDateFormat(data_item.details[fields_item.key], false) : ''
            }
          } else if (fields_item.key === 'join_date') {
            temp_data = {
              ...temp_data,
              [fields_item.key]: data_item[fields_item.key] ? convertDateFormat(data_item[fields_item.key], false) : ''
            }
          } else if (fields_item.key === 'type') {
            temp_data = {
              ...temp_data,
              [fields_item.key]: data_item.details[fields_item.key] ? getBillFeeDescription(data_item.details, true) : ''
            }
          } else if (fields_item.key === 'sales_number') {
            temp_data = {
              ...temp_data,
              [fields_item.key]: data_item[fields_item.key] ? `${data_item[fields_item.key]}` : ''
            }
          } else {
            temp_data = {
            ...temp_data,
              [fields_item.key]: data_item[fields_item.key] !== null ? data_item[fields_item.key] : ''
            }
          }
        })

        data.push(temp_data)
      })

      this.excel_json.fields = fields;
      this.excel_json.data = data;
    },
  }
}
</script>

<style lang="scss" scoped>
.contract-data {
  display: flex;
  align-items: center;
  > div {
    flex-basis: 33.33%;
    text-align: center;
    &:first-child {
      text-align: left;
    }
    &:last-child {
      text-align: right;
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/views/Backstage/yf/components/modal/DetailedReportModal.vue